import { definitionFactory } from '../definitionFactory';
import { onDeleteAction } from '../definitionsDeleteAction';

export const isFinishedDefinition = definitionFactory({
  key: 'is_finished',
  mapper: jsonQueryValue => [
    {
      label: 'Дом сдан',
      value: jsonQueryValue,
    },
  ],
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'is_finished', options);
  },
});
